import React, { ReactNode, useMemo } from 'react';
import { StatusBar } from 'react-native';
import { grid } from '@shared/styles';
import { Props } from './props';
import { MBBottomSheetTitleBar } from './titleBar';

export function useDimensions(): { fullTop: number; initialTop: number } {
  return useMemo(() => {
    const windowHeight = window.innerHeight - Number(StatusBar.currentHeight || 0);
    const initialTop = windowHeight / 2;

    return {
      fullTop: grid(6),
      initialTop,
    };
  }, []);
}

export function useTitleBar(
  title?: Props['title'],
  renderTitleBar?: Props['renderTitleBar'],
): ReactNode {
  return useMemo<ReactNode>(() => {
    if (title) {
      return <MBBottomSheetTitleBar title={title} />;
    }
    if (renderTitleBar) {
      return renderTitleBar();
    }
    return null;
  }, [renderTitleBar, title]);
}
